import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-bg py-16 md:py-24 border-t border-white/5" data-id="element-103">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-104">
        {/* Urgency copy */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="font-inter text-xl md:text-2xl text-white mb-8 leading-relaxed" data-id="element-105">
          Every day you wait is another day your collection is{' '}
          <span className="text-orange-accent" data-id="element-106">visible</span>,{' '}
          <span className="text-orange-accent" data-id="element-107">vulnerable</span>, and{' '}
          <span className="text-orange-accent" data-id="element-108">at risk</span>.
        </motion.p>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-8" data-id="element-109">
          <motion.button onClick={() => document.getElementById('checkout')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group inline-flex items-center gap-3 px-8 py-4 bg-orange-accent text-white font-inter font-bold text-lg uppercase tracking-wide rounded-sm transition-all duration-300 hover:bg-orange-accent/90 hover:scale-[1.02] active:scale-[0.98]" whileHover={{
          boxShadow: '0 0 30px rgba(224, 123, 57, 0.4)'
        }} data-id="element-110">
            <span data-id="element-111">GET THE BLUEPRINT — $6.36</span>
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-112" />
          </motion.button>
        </motion.div>

        {/* Disclaimer */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="font-inter text-xs text-concrete/60 max-w-lg mx-auto leading-relaxed" data-id="element-113">
          This is a digital product. Upon purchase, you will receive instant
          access to download the complete Concrete Bunker Blueprint guide. All
          sales are backed by our 60-day money-back guarantee.
        </motion.p>
      </div>
    </section>;
}